import { combineReducers } from "@reduxjs/toolkit";
import { googleOAuthReducer } from "@myRedux/oauth/google/googleOAuthReducer";

export const oauthReducer = combineReducers({
  google: googleOAuthReducer
})